// removed by extract-text-webpack-plugin
module.exports = {"detail":"_4P5FRZLTngmMYigXjEztD"};


//////////////////
// WEBPACK FOOTER
// ./src/components/lotDetailCard/styles.css
// module id = 1606
// module chunks = 0